import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  Modal,
  Radio,
  Row,
  Space,
  TimePicker,
} from 'antd';

import dayjs from 'dayjs';

import { EditCommunicationHistoryRecord } from 'app/redux/actions/InitiativeUsher';

const EditCommunicationRecordModal = ({ show, setShow, data, setData }) => {
  const [showOtherMethodField, setShowOtherMethodField] = useState(
    !communicationMethodsArray.includes(data.communicationMethod),
  );
  const dispatch = useDispatch();
  const Close = () => {
    setData(null);
    setShow(false);
  };

  const onFinish = async values => {
    if (values.communication_method === 'Others')
      values.communication_method = values.other_communication_method;
    if (values.time) values.time = dayjs(values.time).format('HH:mm');
    values.date = dayjs(values.date).format('YYYY-MM-DD');
    await dispatch(EditCommunicationHistoryRecord(data.pk, values));
    window.location.reload();
  };

  const communicationMethodOnChange = event => {
    if (event.target.value === 'Others') setShowOtherMethodField(true);
    else setShowOtherMethodField(false);
  };

  return (
    <Modal footer={null} open={show} onCancel={Close} width="600px">
      <div className="modal-body">
        <Form onFinish={onFinish}>
          <Form.Item
            name="date"
            label="Date"
            rules={[{ required: true }]}
            initialValue={dayjs(data.date)}
          >
            <DatePicker
              use12Hours={true}
              format="YYYY-MM-DD"
              style={{ width: '100%' }}
            />
          </Form.Item>

          <Form.Item
            name="time"
            label="Time"
            initialValue={data.time ? dayjs(data.time, 'HH:mm') : null}
          >
            <TimePicker
              format="HH:mm"
              use12Hours={true}
              style={{ width: '100%' }}
            />
          </Form.Item>

          <Form.Item
            name="communication_method"
            label="Communication Method"
            rules={[{ required: true }]}
            initialValue={
              !communicationMethodsArray.includes(data.communicationMethod)
                ? 'Others'
                : data.communicationMethod
            }
          >
            <Radio.Group onChange={communicationMethodOnChange}>
              <Space direction="vertical">
                <Radio value="Phone Call">Phone Call</Radio>
                <Radio value="Email">Email</Radio>
                <Radio value="WhatsApp Call">WhatsApp Call</Radio>
                <Radio value="WhatsApp Message">WhatsApp Message</Radio>
                <Radio value="SMS">SMS</Radio>
                <Radio value="Others">
                  Others
                  {showOtherMethodField && (
                    <Form.Item
                      className="mb-0"
                      name="other_communication_method"
                      rules={[{ required: true }]}
                      initialValue={
                        !communicationMethodsArray.includes(
                          data.communicationMethod,
                        )
                          ? data.communicationMethod
                          : ''
                      }
                    >
                      <Input
                        showCount
                        maxLength={30}
                        name="other_communication_method"
                      />
                    </Form.Item>
                  )}
                </Radio>
              </Space>
            </Radio.Group>
          </Form.Item>

          <Form.Item
            name="comments"
            label="Comments"
            rules={[{ required: true }]}
            initialValue={data.comments}
          >
            <Input showCount maxLength={255} />
          </Form.Item>

          <Row gutter={(4, 4)}>
            <Col>
              <Form.Item labelCol={{ span: 6 }}>
                <Button type="primary" htmlType="submit">
                  Submit
                </Button>
              </Form.Item>
            </Col>
            <Col>
              <Form.Item wrapperCol={{ span: 6 }}>
                <Button
                  onClick={() => {
                    setData(null);
                    Modal.destroyAll();
                  }}
                >
                  Cancel
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </div>
    </Modal>
  );
};

export default EditCommunicationRecordModal;

const communicationMethodsArray = [
  'Phone Call',
  'Email',
  'WhatsApp Call',
  'WhatsApp Message',
  'SMS',
];
